import appStore from 'store';
import api from './api';

const store = {

    namespaced: true,

    state: {
        userTags: [],
        tagTotal: 0,
        machineType:[],
        userIds:'',
    },

    mutations: {
        setUserTags(state, payload) {
            console.log(payload[0].userId)
            state.userIds = payload[0].userId;
            state.userTags = payload;
        },
        setTagTotal(state, payload) {
            state.tagTotal = payload;
        },
        setMachineType(state,payload) {
            state.machineType = payload;
        }
    },

    actions: {
        findUserTags({commit}, data) {
            api.getUserTags(data).then(response => {
                commit('setUserTags', response.data.list);
                commit('setTagTotal', response.data.totalCount);
            })
        },

        findMachineType({commit}) {
            api.getMachineType().then(response => {
                commit('setMachineType',response.data);
            })
        }
    }

}

appStore.registerModule('userTags',store);
